import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container } from "reactstrap";
import DashboardLayout from "./DashboardLayout";
import { useUser } from "./Context/UserContext";


const CreateTicket = () => {

    const [formData, setFormData] = useState({
        userName: "",
        emailId: "",
        issueType: "",
        issueDescription: "",
        attachment: null
    });

    const { user } = useUser();
    const [records, setRecords] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [errors, setErrors] = useState({});
    const [adminTickets, setAdminTickets] = useState([]);


    useEffect(() => {
        console.log("LOGIN USER DATA:", user);
    }, [user]);
    // Handle textbox changes
    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        setErrors(prev => ({
            ...prev,
            [name]: ""
        }));

    };

    const displayValue = (value) => {

        if (value === null || value === undefined) {
            return "";
        }

        if (typeof value === "object") {

            if (Array.isArray(value)) {
                return value.join(", ");
            }

            return JSON.stringify(value);
        }

        return String(value);
    };

    // File upload
    const handleFileChange = (e) => {

        setFormData(prev => ({
            ...prev,
            attachment: e.target.files[0]
        }));

    };
    useEffect(() => {

        if (user?.roles?.length > 0) {

            const loggedUser = user.roles[0];

            setFormData(prev => ({
                ...prev,
                userName: String(loggedUser.username || ""),
                emailId: String(loggedUser.emailId || "")
            }));

        }

    }, [user]);
    const updateStatus = async (id, status) => {
        try {

            console.log("UPDATE CLICKED");
            console.log("ID:", id);
            console.log("STATUS:", status);

            const response = await axios.put(
                `/api/CreateTicket/status/${id}`,
                {
                    status: status
                }
            );

            console.log(response.data);

            alert("Status Updated");

            fetchAllTickets();
            fetchTickets();

        }
        catch (err) {

            console.log(
                "UPDATE ERROR:",
                err.response?.data || err
            );

        }
    };

    useEffect(() => {

        if (user?.roles?.length > 0) {

            fetchTickets(); // Always load My Tickets

            const email = user.roles[0].emailId?.toLowerCase();

            if (email === "latha.kamaraj@mindteck.com") {
                fetchAllTickets(); // Load All Tickets only for admin
            }

        }

    }, [user]);


    const fetchTickets = async () => {

        try {

            const email = user?.roles?.[0]?.emailId;

            const res = await axios.get(
                `/api/CreateTicket/tickets?emailId=${email}`
            );

            console.log("MY TICKETS:", res.data);

            setRecords(res.data);

        }
        catch (error) {

            console.log("MY TICKET ERROR:", error);

        }

    };
    const fetchAllTickets = async () => {
        try {
            const res = await axios.get("/api/CreateTicket/alltickets");

            console.log("ALL TICKETS:", res.data);

            setAdminTickets(res.data);

        } catch (err) {
            console.log("ALL TICKETS ERROR:", err);
        }
    };
    // Clear form

    const clearForm = () => {

        setFormData({

            userName: "",
            emailId: "",
            issueType: "",
            issueDescription: "",
            attachment: null

        });


        setErrors({});

    };
    const handleSaveTicket = async () => {
        try {

            const form = new FormData();

            form.append("userName", formData.userName);
            form.append("emailId", formData.emailId);
            form.append("issueType", formData.issueType);
            form.append("issueDescription", formData.issueDescription);

            if (formData.attachment) {
                form.append("attachment", formData.attachment);
            }

            console.log("SENDING DATA:", formData);
            const response = await axios.post(
                "/api/CreateTicket/create",
                form,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            console.log("SAVE RESPONSE:", response.data);
            alert("Ticket Created Successfully");

            clearForm();

            fetchTickets();

            if (user?.roles?.[0]?.emailId?.toLowerCase() === "latha.kamaraj@mindteck.com") {
                fetchAllTickets();
            }
        }
        catch (error) {

            console.log(
                "Create Ticket Error:",
                error.response?.data
            );

            alert(
                error.response?.data || "Creation failed"
            );

        }
    };
    return (

        <DashboardLayout>


            <Container
                fluid
                className="px-4 py-4"
                style={{
                    background: "var(--bs-tertiary-bg)",
                    minHeight: "100vh"
                }}
            >
                <div
                    style={{
                        background: "linear-gradient(90deg,#0d6efd,#6610f2)",
                        borderRadius: "10px",
                        padding: "12px",
                        marginBottom: "20px"
                    }}
                >

                    <h3
                        className="text-center"
                        style={{
                            color: "#fff",
                            fontWeight: "700"
                        }}
                    >
                        Create Ticket
                    </h3>


                </div>

                <div
                    style={{
                        background: "var(--bs-body-bg)",
                        color: "var(--bs-body-color)",
                        border: "1px solid var(--bs-border-color)",
                        borderRadius: "15px",
                        padding: "20px",
                        boxShadow: "0 8px 20px rgba(0,0,0,.15)"
                    }}
                >
                    <div className="row">


                        {/* USER NAME */}

                        <div className="col-md-6 mb-3">


                            <label
                                style={{
                                    fontWeight: "600",
                                    color: "#0d6efd"
                                }}
                            >
                                User Name
                            </label>


                            <input
                                type="text"
                                name="userName"
                                value={formData.userName}
                                className="form-control"
                                disabled
                            />


                            {
                                errors.userName &&
                                <small style={{ color: "red" }}>
                                    {errors.userName}
                                </small>
                            }


                        </div>

                        {/* EMAIL */}

                        <div className="col-md-6 mb-3">
                            <label
                                style={{
                                    fontWeight: "600",
                                    color: "#6f42c1"
                                }}
                            >
                                Email ID
                            </label>
                            <input
                                type="email"
                                name="emailId"
                                value={formData.emailId}
                                className="form-control"
                                disabled
                            />
                            {
                                errors.emailId &&
                                <small style={{ color: "red" }}>
                                    {errors.emailId}
                                </small>
                            }

                        </div>

                    </div>

                    <div className="row">


                        {/* ISSUE TYPE */}

                        <div className="col-md-6 mb-3">


                            <label
                                style={{
                                    fontWeight: "600",
                                    color: "#198754"
                                }}
                            >
                                Issue Type <span style={{ color: "red" }}>*</span>
                            </label>

                            <input
                                type="text"
                                name="issueType"
                                value={formData.issueType}
                                onChange={handleChange}
                                placeholder="Enter Issue Type"
                                className="form-control"
                                required
                            />
                            {
                                errors.issueType &&
                                <small style={{ color: "red" }}>
                                    {errors.issueType}
                                </small>
                            }

                        </div>



                    </div>


                    {/* DESCRIPTION */}

                    <div className="row">


                        <div className="col-md-12 mb-3">


                            <label
                                style={{
                                    fontWeight: "600",
                                    color: "#dc3545"
                                }}
                            >
                                Issue Description <span style={{ color: "red" }}>*</span>
                            </label>


                            <textarea
                                name="issueDescription"
                                value={formData.issueDescription}
                                onChange={handleChange}
                                placeholder="Enter Issue Description"
                                rows="4"
                                className="form-control"
                                required
                            />
                            {
                                errors.issueDescription &&
                                <small style={{ color: "red" }}>
                                    {errors.issueDescription}
                                </small>
                            }
                        </div>
                    </div>

                    {/* ATTACHMENT */}

                    <div className="row">


                        <div className="col-md-6 mb-3">


                            <label
                                style={{
                                    fontWeight: "600"
                                }}
                            >
                                Attachment <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                                type="file"
                                className="form-control"
                                onChange={handleFileChange}
                                required
                            />

                        </div>
                    </div>
                    <div className="text-end">

                        <button

                            type="button"

                            onClick={handleSaveTicket}

                            style={{
                                background: "#198754",
                                color: "#fff",
                                border: "none",
                                borderRadius: "8px",
                                padding: "8px 25px",
                                marginRight: "10px"
                            }}

                        >

                            💾 Save

                        </button>

                        <button

                            type="button"

                            onClick={clearForm}

                            style={{
                                background: "#dc3545",
                                color: "#fff",
                                border: "none",
                                borderRadius: "8px",
                                padding: "8px 25px"
                            }}

                        >

                            ✖ Cancel

                        </button>



                    </div>



                </div>

                {/* TABLE */}



                <div
                    style={{
                        marginTop: "30px",
                        background: "var(--bs-body-bg)",
                        color: "var(--bs-body-color)",
                        border: "1px solid var(--bs-border-color)",
                        padding: "15px",
                        borderRadius: "10px"
                    }}
                >


                    <h5>
                        My Tickets
                    </h5>



                    <table
                        className="table table-bordered text-center"
                        style={{
                            width: "100%",
                            tableLayout: "fixed"
                        }}
                    >


                        <thead
                            style={{
                                background: "#0d6efd",
                                color: "#fff"
                            }}
                        >

                            <tr>

                                <th>User Name</th>

                                <th>Email ID</th>

                                <th>Issue Type</th>

                                <th>Description</th>

                                <th>Attachment</th>

                                <th>Status</th>

                            </tr>


                        </thead>



                        <tbody>


                            {
                                records.map((row, index) => (


                                    <tr key={index}>


                                        <td>
                                            {displayValue(row.userName)}
                                        </td>

                                        <td>
                                            {displayValue(row.emailId)}
                                        </td>

                                        <td>
                                            {displayValue(row.issueType)}
                                        </td>

                                        <td>
                                            {displayValue(row.issueDescription)}
                                        </td>



                                        <td>
                                            {
                                                row.attachmentPath ?

                                                    <button
                                                        type="button"
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() =>
                                                            setSelectedFile(
                                                                `https://localhost:44334/uploads/${displayValue(row.attachmentPath)}`
                                                            )
                                                        }
                                                    >
                                                        View
                                                    </button>

                                                    :

                                                    "No File"
                                            }
                                        </td>


                                        <td>
                                            {displayValue(row.status) || "Open"}
                                        </td>



                                    </tr>


                                ))
                            }



                        </tbody>



                    </table>
                    {
                        user?.roles?.[0]?.emailId?.toLowerCase() === "latha.kamaraj@mindteck.com" &&
                        <div
                                style={{
                                    marginTop: "30px",
                                    background: "var(--bs-body-bg)",
                                    color: "var(--bs-body-color)",
                                    border: "1px solid var(--bs-border-color)",
                                    padding: "20px",
                                    borderRadius: "15px",
                                    boxShadow: "0 5px 20px rgba(0,0,0,0.15)"
                                }}
                        >

                            <h5
                                style={{
                                    color: "#0d6efd",
                                    fontWeight: "700"
                                }}
                            >
                                🎫 All Support Tickets
                            </h5>

                            <table className="table table-bordered text-center">

                                <thead className="table-dark">

                                    <tr>

                                        <th>Ticket Number</th>
                                        <th>User</th>
                                        <th>Email</th>
                                        <th>Issue</th>
                                        <th>Description</th>
                                        <th>Attachment</th>
                                        <th>Status</th>

                                    </tr>

                                </thead>


                                <tbody>
                                    {
                                        adminTickets.map((row, index) => (

                                            <tr key={index}>
                                                <td>{displayValue(row.ticketNumber)}</td>

                                                <td>{displayValue(row.userName)}</td>

                                                <td>{displayValue(row.emailId)}</td>

                                                <td>{displayValue(row.issueType)}</td>

                                                <td>{displayValue(row.issueDescription)}</td>



                                                <td
                                                    style={{
                                                        width: "100px",
                                                        minWidth: "100px",
                                                        maxWidth: "100px",
                                                        textAlign: "center",
                                                        verticalAlign: "middle"
                                                    }}
                                                >
                                                    {row.attachmentPath ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-sm"
                                                            style={{
                                                                width: "90px",
                                                                minWidth: "90px",
                                                                maxWidth: "90px",
                                                                whiteSpace: "nowrap",
                                                                padding: "6px 8px",
                                                                fontSize: "13px"
                                                            }}
                                                            onClick={() =>
                                                                setSelectedFile(
                                                                    `https://localhost:44334/uploads/${displayValue(row.attachmentPath)}`
                                                                )
                                                            }
                                                        >
                                                            View
                                                        </button>
                                                    ) : (
                                                        <span style={{ fontSize: "13px" }}>No File</span>
                                                    )}
                                                </td>


                                                <td>

                                                    <select
                                                        className="form-control"
                                                        style={{
                                                            width: "110px",
                                                            minWidth: "110px",
                                                            maxWidth: "110px"
                                                        }}
                                                        value={row.status || "Open"}
                                                        onChange={(e) =>
                                                            updateStatus(row.id, e.target.value)
                                                        }
                                                    >
                                                        <option value="Open">
                                                            🟢 Open
                                                        </option>

                                                        <option value="In Progress">
                                                            🟡 In Progress
                                                        </option>

                                                        <option value="Closed">
                                                            🔴 Closed
                                                        </option>

                                                    </select>

                                                </td>

                                            </tr>

                                        ))
                                    }
                                </tbody>


                            </table>


                        </div>

                    }


                </div>
                {
                    selectedFile &&

                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0,0,0,0.6)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 9999
                        }}
                    >

                        <div
                                style={{
                                    width: "80%",
                                    height: "80%",
                                    background: "var(--bs-body-bg)",
                                    color: "var(--bs-body-color)",
                                    borderRadius: "10px",
                                    padding: "20px",
                                    position: "relative"
                                }}
                        >


                            <button
                                onClick={() => setSelectedFile(null)}
                                style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "10px",
                                    background: "red",
                                    color: "white",
                                    border: "none",
                                    padding: "5px 15px",
                                    borderRadius: "5px"
                                }}
                            >
                                X
                            </button>


                            <img
                                src={selectedFile}
                                alt="Attachment"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                }}
                            />


                        </div>

                    </div>

                }

            </Container>


        </DashboardLayout>
    );
};
export default CreateTicket;